// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UnclaimedRequest styles */
.main-content-table {
  padding: 20px;
}

.date-input {
  width: auto;
  min-width: 150px;
}

.card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.card-body {
  padding: 1rem;
}

.form-label.small {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.form-select,
.form-control {
  font-size: 0.875rem;
}

.is-invalid {
  border-color: #dc3545;
}

.btn-success {
  background-color: #019440;
  border-color: #019440;
}

.btn-success:hover {
  background-color: #017832;
  border-color: #017832;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/UnclaimedRequest/UnclaimedRequest.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/* UnclaimedRequest styles */\n.main-content-table {\n  padding: 20px;\n}\n\n.date-input {\n  width: auto;\n  min-width: 150px;\n}\n\n.card {\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n}\n\n.card-body {\n  padding: 1rem;\n}\n\n.form-label.small {\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.form-select,\n.form-control {\n  font-size: 0.875rem;\n}\n\n.is-invalid {\n  border-color: #dc3545;\n}\n\n.btn-success {\n  background-color: #019440;\n  border-color: #019440;\n}\n\n.btn-success:hover {\n  background-color: #017832;\n  border-color: #017832;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
